module.exports = __webpack_public_path__ + "static/media/I.a6740bbd.webp";